let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aWToy")).then(() => parcelRequire('bg9up'));